<template>
    <div>
        <img @click="whatsappOnClick" alt="whatsapp-logo" class="whatsapp-float" src="../assets/icons/whatsapp-float.png">

    </div>
</template>

<script>
    export default {
        methods:{
            whatsappOnClick: function () {
                window.open("https://wa.me/918237629111")
            }
        }
    };
</script>

<style scoped>
    @import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap");
    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        font-family: "Poppins";
        /* background-color: black;*/
        /*border: 1px solid red;*/
    }
    .whatsapp-float{
        height: 70px;
        position: fixed;
        bottom: 20px;
        right: 20px;
        z-index: 100;
    }
    .whatsapp-float:hover{
        cursor:pointer
    }
</style>